import { createFeatureSelector, createSelector } from '@ngrx/store';
const getRoles = createFeatureSelector<any>('roles');

export const getAllRolesLoading = createSelector(
  getRoles,
  (state: any) => state.rolesLoading
);
/**
 * Get all roles
 */

export const getAllRoles = createSelector(
  getRoles,
  (state: any) => state.roles
);

/**
 * Get Roles Details
 */
export const getRolesDetail = createSelector(
  getRoles,
  (state: any) => state.rolesDetail
);

/**
 * Get Management Types
 */

export const getManagementTypes = createSelector(
  getRoles,
  (state: any) => state.managementTypes
);

/**
 * Get Operations
 */
export const getOperations = createSelector(
  getRoles,
  (state: any) => state.operations
);
